var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
var Boton = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "button" : _b, texto = _a.texto, icono = _a.icono, _c = _a.error, error = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, handleOnClick = _a.handleOnClick, _e = _a.variant, variant = _e === void 0 ? "primary" : _e;
    return (React.createElement(Button, { type: type, error: error, texto: texto, className: "boton", role: "button", disabled: disabled, variant: variant, onClick: handleOnClick && (function () { return handleOnClick(); }) },
        icono && React.createElement(FontAwesomeIcon, { icon: icono }),
        " ",
        texto));
};
var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n\n  background-color: ", ";\n\n  border: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 20px;\n  margin: 20px;\n  font-size: 18px;\n  border-radius: 8px;\n  cursor: pointer;\n\n  svg {\n    margin-right: ", ";\n  }\n\n  :hover {\n    color: ", ";\n\n    background-color: ", ";\n\n    border: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n  }\n"], ["\n  color: ", ";\n\n  background-color: ", ";\n\n  border: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 20px;\n  margin: 20px;\n  font-size: 18px;\n  border-radius: 8px;\n  cursor: pointer;\n\n  svg {\n    margin-right: ", ";\n  }\n\n  :hover {\n    color: ", ";\n\n    background-color: ", ";\n\n    border: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    switch (variant) {
        case "primary":
            return theme.addToCartTexto;
        case "outline":
            return theme.botonOutlineTexto;
        default:
            return theme.addToCartTexto;
    }
}, function (_a) {
    var theme = _a.theme, variant = _a.variant, error = _a.error;
    if (error)
        return theme.stop;
    switch (variant) {
        case "primary":
            return theme.addToCartFondo;
        case "outline":
            return theme.botonOutlineFondo;
        default:
            return theme.addToCartFondo;
    }
}, function (_a) {
    var theme = _a.theme, variant = _a.variant, error = _a.error;
    if (error)
        return "1px solid ".concat(theme.stop);
    switch (variant) {
        case "primary":
            return "none";
        case "outline":
            return "1px solid ".concat(theme.botonOutlineBorder);
        default:
            return "none";
    }
}, function (_a) {
    var texto = _a.texto;
    return (texto ? "8px" : "0");
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    switch (variant) {
        case "primary":
            return theme.addToCartTextoHover;
        case "outline":
            return theme.botonOutlineTextoHover;
        default:
            return theme.addToCartTextoHover;
    }
}, function (_a) {
    var theme = _a.theme, variant = _a.variant, error = _a.error;
    if (error)
        return theme.stopOscuro;
    switch (variant) {
        case "primary":
            return theme.addToCartFondoHover;
        case "outline":
            return theme.addToCartFondo;
        default:
            return theme.addToCartFondo;
    }
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    switch (variant) {
        case "outline":
            return "1px solid ".concat(theme.botonOutlineBorderHover);
        default:
            return "none";
    }
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return error ? theme.stopClaro : theme.primarioClaro;
});
export default Boton;
var templateObject_1;
